import { D as Drawer } from "./drawer-B-fNrZO_.js";
class DrawerClickAndCollect extends Drawer {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback();
    this.variantId = "";
  }
  openDrawer() {
    super.openDrawer();
    const variantId = document.querySelector('#product input[name="id"]').value;
    if (this.isPickupDispoInit && this.variantId == variantId) {
      return;
    }
    this.variantId = variantId;
    if (this.isPickupDispoInit) {
      this.drawerContentEl.innerHTML = "";
    }
    this.productUrl = `${this.dataset.productUrl}${variantId ? `?variant=${variantId}` : ""}`;
    if (this.productUrl) {
      this.drawerContentEl.classList.add("drawer__content--loading");
      this.fetchClickAndCollection();
    }
  }
  fetchClickAndCollection() {
    const url = `${this.productUrl}&view=click-and-collect`;
    fetch(url).then((response) => response.text()).then((html) => {
      this.drawerContentEl.innerHTML = html;
      this.isPickupDispoInit = true;
      this.drawerContentEl.classList.remove("drawer__content--loading");
    }).catch((error) => {
      this.drawerContentEl.classList.remove("drawer__content--loading");
      console.error(error);
    });
  }
}
customElements.define("w3-drawer-click-and-collect", DrawerClickAndCollect);
class ClickAndCollectButton extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector("button");
    if (!button) {
      console.error("Button inside the component is undefined");
      return;
    }
    button.addEventListener("click", () => {
      const { storeName, storeProductUrl, storeHours } = button.dataset;
      const store = {
        storeName,
        storeProductUrl,
        storeHours
      };
      const storefrontToken = Shopify.shop.includes("dev") ? "c4576cfaf62ccc5e0e9f045e61e68ced" : "9cd4499128010fb716b517389751c3fd";
      const variantId = document.querySelector('main .product product-form.product-form input[name="id"]').value;
      if (!variantId) {
        console.error("An error occured while trying to fetch the variantId value.");
        return;
      }
      const lineItems = [
        {
          variantId: `gid://shopify/ProductVariant/${variantId}`,
          quantity: 1
        }
      ];
      const checkoutQuery = `mutation checkoutCreate($input: CheckoutCreateInput!) {
              checkoutCreate(input: $input) {
                checkout {
                   id
                   webUrl
                   lineItems(first: 5) {
                     edges {
                       node {
                         title
                         quantity
                       }
                     }
                   }
                }
              }
            }`;
      const body = {
        query: checkoutQuery,
        variables: {
          input: { lineItems }
        }
      };
      fetch(`https://${Shopify.shop}/api/graphql`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Shopify-Storefront-Access-Token": storefrontToken
        },
        body: JSON.stringify(body)
      }).then((res) => res.json()).then((result) => {
        const { webUrl } = result.data.checkoutCreate.checkout;
        localStorage.setItem("ccStore", JSON.stringify(store));
        window.location.href = webUrl.replace(Shopify.shop, "www.m-moustache.com");
      });
    });
  }
}
customElements.define("w3-click-and-collect-button", ClickAndCollectButton);
class ClickAndCollectDrawerOpener extends HTMLElement {
  // use a web component to self-init and bind events when component is created/destroyed
  connectedCallback() {
    const Drawer2 = document.querySelector(this.dataset.drawerIdentifier);
    if (Drawer2) {
      Drawer2.bindEvents();
    }
  }
}
customElements.define("w3-click-and-collect-opener", ClickAndCollectDrawerOpener);
